import * as tslib_1 from "tslib";
import { QueryEntity } from '@datorama/akita';
import { map } from 'rxjs/operators';
import { SoilAnalysisUploadStore } from './soil-analysis-upload.store';
import { Observable } from 'rxjs';
// import {SoilAnalysisFilesUploadingState} from '../../_shared/components/files-upload-info-box/constants/files-upload-state';
import { SoilAnalysisFileStatus } from './constants/soil-analysis-file-status';
import * as i0 from "@angular/core";
import * as i1 from "./soil-analysis-upload.store";
var SoilAnalysisUploadQuery = /** @class */ (function (_super) {
    tslib_1.__extends(SoilAnalysisUploadQuery, _super);
    // currentState$: Observable<SoilAnalysisFilesUploadingState> =
    // combineLatest(([this.uploading$, this.uploadingItems$, this.notUploaded$]))
    //   .pipe(map(([uploading, uploadingItems, notUploaded]) => {
    //     if (uploading) {
    //       return SoilAnalysisFilesUploadingState.Loading;
    //     } else if (notUploaded.length) {
    //       return SoilAnalysisFilesUploadingState.Error;
    //     } else if (uploadingItems.length) {
    //       return SoilAnalysisFilesUploadingState.Success;
    //     } else {
    //       return SoilAnalysisFilesUploadingState.Inactive;
    //     }
    //   }));
    function SoilAnalysisUploadQuery(store) {
        var _this = _super.call(this, store) || this;
        _this.store = store;
        _this.uploadingItems$ = _this.selectAll();
        _this.uploading$ = _this.uploadingItems$.pipe(map(function (items) {
            return items.some(function (item) { return item.data.status === SoilAnalysisFileStatus.Processing; });
        }));
        _this.uploadingInProgress$ = _this.uploadingItems$
            .pipe(map(function (items) {
            return items.some(function (item) { return item.data.status === SoilAnalysisFileStatus.Processing; });
        }));
        _this.notUploaded$ = _this.uploadingItems$.pipe(map(function (items) {
            return items.filter(function (item) { return item.error; });
        }));
        _this.uploaded$ = _this.uploadingItems$.pipe(map(function (items) {
            return items.filter(function (item) { return !item.loading; });
        }));
        return _this;
    }
    SoilAnalysisUploadQuery.ngInjectableDef = i0.defineInjectable({ factory: function SoilAnalysisUploadQuery_Factory() { return new SoilAnalysisUploadQuery(i0.inject(i1.SoilAnalysisUploadStore)); }, token: SoilAnalysisUploadQuery, providedIn: "root" });
    return SoilAnalysisUploadQuery;
}(QueryEntity));
export { SoilAnalysisUploadQuery };
